import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowLastSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2.707 5.293 6 2 9.293l.707.707 4-4-4-4L2 2.707ZM10 2H9v8h1V2Z"
    />
  </svg>
);
export default IconArrowLastSizeXs;
